import React from "react"
import PropTypes from "prop-types"

const PageTitle = ({ className, children }) => {
  return (
    <div className="mb-12 lg:mb-20">
      <div className="max-w-max mx-auto">
        <h2
          className={`${className} text-4xl md:text-5xl font-bold text-center font-display leading-relaxed`}
        >
          {children}
        </h2>
        <div className="mt-6 w-1/3 bg-gold h-2 mx-auto md:ml-auto md:mr-0 rounded" />
      </div>
    </div>
  )
}

PageTitle.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
}

PageTitle.defaultProps = {
  className: ``,
}

export default PageTitle
